import { render } from "./MenuDetail.vue?vue&type=template&id=78c920d4&scoped=true&ts=true"
import script from "./MenuDetail.vue?vue&type=script&lang=ts"
export * from "./MenuDetail.vue?vue&type=script&lang=ts"

import "./MenuDetail.vue?vue&type=style&index=0&id=78c920d4&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c920d4"]])

export default __exports__